<template>
  <div class="clm-slider-btns__cnt">
    <button type="button" class="clm-frm-btn" :class="{'clm-frm-btn--color' : isColor}" @click="$emit('action')">
      <span class="clm-frm-btn__text">
        <slot></slot>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "a-btn",
  props: {
    isColor: {
      type: Boolean,
      default: false,
    }
  }
}
</script>